import { Stack, Typography } from "@mui/material";
import isNil from "lodash/isNil";
import type { FC } from "react";
import type { Currency } from "../../data/BaseEntity";
import { formatNumber } from "../../misc/utils";
import type { CostCurrency } from "../costApi";
import type { CostInvoice } from "../costsUtils";
import { calculateMargin, costAmountInOrderCurrency } from "../costsUtils";

interface Props {
  readonly price: number | null;
  readonly orderCurrency: Currency;
  readonly costCurrency: CostCurrency;
  readonly costInvoices: CostInvoice[];
}

const Margin: FC<Props> = ({ price, orderCurrency: priceCurrency, costCurrency, costInvoices }) => {
  const costInOrderCurrency = costAmountInOrderCurrency(priceCurrency, costCurrency, costInvoices);
  const margin = calculateMargin(price, priceCurrency, costCurrency, costInvoices);
  if (isNil(costInOrderCurrency) || isNil(margin)) {
    return null;
  }
  return (
    <Stack direction="row" spacing={2}>
      <Typography>Marża: {margin}%</Typography>
      {priceCurrency !== costCurrency && (
        <Typography>
          Cena w walucie zamówienia: {formatNumber(costInOrderCurrency)} {priceCurrency}
        </Typography>
      )}
    </Stack>
  );
};

export default Margin;
